<template>
    <div class="fillOrder_box">
      <div class="title">
        {{$t('FillOrder.FillOrder')}}
        <span style="font-size:13px;color:#FF0000;"><i class="el-icon-warning-outline"></i> {{$t('FillOrder.FillOrderTitle')}}</span>
        <p style="font-size: 16px;color:red;font-weight: bold;">{{$t('FillOrder.VisitDate') + '：' + this.reservationMsg}}</p>
        <p></p>
        <el-button size="mini" @click="tiggerPage" class="backToClose">{{$t('back')}}</el-button>
      </div>
      <!-- 进度 -->
      <ProgressPanel :activitiesIndex='activitiesIndex'></ProgressPanel>
      <el-form
        ref="form"
        :model="{list}"
        :inline="false"
      >
        <div v-for="(item,index) in list" :key="index" >
          <div class="visitorMsg" v-if="item.isRealname == 'T'">
            <template>
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#F9F9F9'}" :span-method="objectSpanMethod" border class="order-table" :default-expand-all='true'  :data='item.orderVisitorList'>
                <el-table-column align='center' :label="$t('FillOrder.productName')">
                    <template >
                      <span>{{ item.ticketName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center'  :label="$t('FillOrder.ticketType')">
                    <template >
                      <span>{{ item.isAutoChoose === 'T' ? item.ticketKindName2 : item.ticketKindName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.Quantity')" width="60px">
                    <template >
                      <span>{{ item.selectNum }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.UnitPrice')" width="80px">
                    <template >
                      <span>{{ item.salePrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.Name')">
                    <template slot-scope='scope'>
                      <el-form-item :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.visitorName'" :rules="[{ required: true, message: $t('FillOrder.PleaseYourName')}]">
                        <el-input :placeholder="!scope.row.subTicketId ? $t('FillOrder.PleaseYourName') : '请输入儿童姓名'" v-model="scope.row.visitorName"></el-input>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column align='center'  v-if="item.needSpecialCertificate === 'T'" :label="$t('FillOrder.SpecialIDType')">
                    <template slot-scope='scope'>
                        <el-input disabled v-model="scope.row.specialCertificateTypeCn"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align='center' v-if="item.needSpecialCertificate === 'T'" :label="$t('FillOrder.SpecialIDNumber')">
                    <template slot-scope='scope'>
                      <el-form-item :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.specialCertificate'" :rules="[{ required: true, message: $t('FillOrder.SpecialIDNumber')}]">
                        <el-input :placeholder="$t('FillOrder.SpecialIDNumber')" v-model="scope.row.specialCertificate"></el-input>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.DocumentType')">
                    <template slot-scope='scope'>
                         <el-select
                            v-model="scope.row.visitorCertificateType"
                            :disabled="scope.row.isAutoChoose === 'T' || !!scope.row.subTicketId"
                            style="display:block"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="i in item.certificateTypeList"
                              :key="i.code"
                              :label="i.name"
                              :value="i.code"
                            ></el-option>
                          </el-select>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.IDNumber')">
                    <template slot-scope='scope'>
                      <el-form-item v-if="scope.row.specialCertificate || item.needSpecialCertificate !== 'T'" :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.visitorCertificateNo'"
                      :rules="[{ required: true, message: $t('FillOrder.IDNumber')}]">
                        <el-input :placeholder="$t('FillOrder.IDNumber')" v-model="scope.row.visitorCertificateNo" @blur="getTicketKind(scope.row, index)"></el-input>
                      </el-form-item>
                      <el-form-item v-else :prop="'list.' + index + '.orderVisitorList.' + scope.$index + '.specialCertificate'"
                      :rules="[{ required: true, message: $t('FillOrder.PleaseSpecialIDNumber')}]">
                        <el-input :placeholder="!scope.row.subTicketId ? $t('FillOrder.PleaseIDNumber') : '请输入儿童证件号'" v-model="scope.row.visitorCertificateNo" @blur="getTicketKind(scope.row, index)"></el-input>
                      </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="isMobile === 'T'" align='center' label='出行人手机号'>
                    <template slot-scope='scope'>
                        <el-input placeholder="请输入手机号" v-model="scope.row.visitorMobile"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='携带儿童数量' width="220">
                    <template slot-scope='scope'>
                        <el-input-number  v-if="!scope.row.subTicketId && scope.row.canCarryChildrenCount && isCanChildren" v-model="scope.row.carryChildrenCount" @change="handleNumChange(index, scope.$index, scope.row, $event)" :min="0" :max="scope.row.canCarryChildrenCount" label="描述文字"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('FillOrder.DeleteThisContact')">
                    <template slot-scope='scope'>
                        <el-button  @click="deleteList(index, scope.$index)" style="background: #869ECD;color: #FFFFFF;">{{$t('FillOrder.Delete')}}</el-button>
                    </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
        <div class="warm-prompt" v-if="warmPrompt">
          <label>{{$t('FillOrder.OutByOrder')}}:</label>
          <span v-html="warmPrompt"></span>
        </div>
      </el-form>
      <el-form ref="formVisitor" :rules="rules" :model="formData">
        <div class="visitorMsg">
          <div class="headline">
            {{$t('FillOrder.information')}}
            <span class="sub">{{$t('FillOrder.informationSub')}}</span>
          </div>
          <div class="msgForm">
            <el-form-item :label="$t('FillOrder.ContactPhoneNumber')" :prop="`contactMobile`">
              <el-input v-model="formData.contactMobile" :placeholder="$t('FillOrder.PleaseenterContact')" style="width:340px"></el-input>
            </el-form-item>
            <el-form-item label="手机验证码" :prop="`code`" v-if="codeshow">
              <el-input
                placeholder="请输入验证码"
                v-model="formData.code"
                style="width:210px;margin-right:10px;"
              ></el-input>
              <el-button
                class="verification-btn"
                type="primary"
                style="width:120px;"
                @click="getVerificationCode"
                :disabled="!verificationBtn"
              >
                <template v-if="verificationBtn">发送验证码</template>
                <template v-else>重新获取({{verificationTime}})</template>
              </el-button>
            </el-form-item>
          </div>
        </div>
        <div class="submitOrder">
          <span>
            {{$t('FillOrder.Quantity')}}:
            <span class="highLight bold">{{Number(count)}}</span>
          </span>
          <span>
            {{$t('FillOrder.TotalAmount')}}：
            <span class="highLight bold">￥{{total}}</span>
          </span>
          <div
            class="submitBtn"
            @click="submitBtn('form')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >{{$t('FillOrder.BuyNow')}}</div>
        </div>
      </el-form>
      <el-dialog
        :title="$t('Announcement')"
        :visible.sync="announcementdialogVisible"
        width="30%"
        :before-close="handleCloseAnnouncement"
      >
        <span>{{msg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="announcementdialogVisible = false">{{$t('Confirm')}}</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { validaCellPhone, validaIDCardNo, specialSymbols } from '../utils/validate'
import { getStaggeredReservationDailyForShow, qucikBuyCode, sendCode, checkCode, createOrder, payAndConfirm, maxQuantit, certificateNo, getDictList2, getInfoConfiguration, getTicketKind, contactMobileValidate, throttle } from '@/api/buyTicket'
import { clearInterval, setInterval } from 'timers'
import ProgressPanel from '../components/ProgressPanel'
import * as math from 'mathjs'
export default {
  components: {
    ProgressPanel
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      if (value) {
        if (validaCellPhone(value)) {
          callback()
        } else {
          return callback(new Error(this.$t('FillOrder.PleaseenterContact')))
        }
      } else {
        callback(new Error(this.$t('FillOrder.PleaseenterContact')))
      }
    }
    const checkIDCardNo = (rule, value, callback) => {
      if (value) {
        if (validaIDCardNo(value.toLocaleUpperCase())) {
          callback()
        } else {
          return callback(new Error(this.$t('FillOrder.PleaseIDNumber')))
        }
      } else {
        callback(new Error(this.$t('FillOrder.PleaseIDNumber')))
      }
    }
    return {
      date: null,
      list: [],
      contactRealName: false,
      formData: {
        contactMobile: null,
        code: ''
      },
      rules: {
        visitorCertificateNo: [{ required: true, message: this.$t('FillOrder.PleaseIDNumber'), trigger: 'blur' }],
        specialCertificate: [{ required: true, message: this.$t('FillOrder.PleaseSpecialIDNumber'), trigger: 'blur' }],
        visitorCertificateNo1: [{ required: true, message: '身份证号错误', trigger: 'blur', validator: checkIDCardNo }],
        visitorName: [{ required: true, message: this.$t('FillOrder.PleaseYourName'), trigger: 'blur' }],
        visitorCertificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        code: [{ required: true, message: this.$t('LoginObj.PleaseCode'), trigger: 'blur' }],
        contactMobile: [{ required: true, message: this.$t('FillOrder.ContactPhoneNumber'), trigger: 'change', validator: checkPhone }]
      },
      verificationBtn: true,
      verificationTime: 60,
      total: 0, // 总价
      count: 0, // 票数
      timer: null,
      codeshow: false,
      fullscreenLoading: false,
      maxQuantit: null,
      announcementdialogVisible: false,
      msg: '',
      numbers: 0,
      specialCertificateType: null,
      isMobile: 'F',
      activitiesIndex: 3,
      warmPrompt: null,
      isCanChildren: false,
      reservationMsg: null
    }
  },
  props: ['buydataList', 'selectDate'],
  created () {
    // 可携带儿童
    this.isCanChildren = localStorage.getItem('isCanChildren') && Number(localStorage.getItem('isCanChildren'))
    // 温馨提示
    this.warmPrompt = localStorage.getItem('warmPrompt')
    this.getInfoConfiguration()
    this.getDictList2()
    this.qucikBuyCode()
    this.getmaxQuantit()
    this.list = JSON.parse(this.$route.query.dataList)
    if (this.$route.query.reservationId) {
      getStaggeredReservationDailyForShow({
        staggeredReservationDailyId: this.$route.query.reservationId
      }).then(res => {
        if (res.code === 0) {
          const data = res.data
          this.date = data.reservationDate
          this.reservationMsg = data.reservationDate + ' ' + data.reservationBeginTime + '~' + data.reservationEndTime
        }
      })
    } else {
      this.date = this.$route.query.selectDate
      this.reservationMsg = this.$route.query.selectDate
    }
  },
  methods: {
    handleNumChange (index, subIndex) {
      const item = this.list[index].orderVisitorList[subIndex]
      // 增加
      if (item.childrenCount < item.carryChildrenCount) {
        let arr = []
        // const visitorCertificateType = item.certificateTypeList.length > 0 ? '1' : null
        for (let i = 0; i < item.carryChildrenCount - item.childrenCount; i++) {
          arr.push({
            visitorName: null,
            visitorCertificateType: '1',
            visitorCertificateNo: null,
            certificateImageUrl: null,
            certificateImageShow: null,
            specialCertificateTypeCn: null,
            specialCertificateType: null,
            isAutoChoose: item.isAutoChoose,
            subTicketId: item.childTicketId,
            ticketId: item.ticketId,
            parentTicketId: item.ticketId,
            canCarryChildrenCount: item.carryChildrenCount
          })
        }
        this.list[index].orderVisitorList.splice(subIndex + 1, 0, ...arr)
        this.list[index].orderVisitorList[subIndex].childrenCount = item.carryChildrenCount
      } else if (item.childrenCount > 0) {
        // 找到儿童票
        const arr = this.list[index].orderVisitorList.slice(subIndex + 1)
        let find = false
        let noInfodx = null
        let nodx = null
        arr.forEach((j, jix) => {
          if (!find) {
            // 当遇到没有parentTicketId属性的值是，到下一张票
            if (j.subTicketId) {
              // 若果有信息为空的，记录下来
              if (!j.visitorName && !j.visitorCertificateNo) {
                noInfodx = jix
                find = true
              }
              nodx = jix
            } else {
              find = true
            }
          }
        })
        if (noInfodx !== null) {
          this.list[index].orderVisitorList.splice(noInfodx + subIndex + 1, item.childrenCount - item.carryChildrenCount)
        } else {
          this.list[index].orderVisitorList.splice(nodx + subIndex + 1, item.childrenCount - item.carryChildrenCount)
        }
        this.list[index].orderVisitorList[subIndex].childrenCount = item.carryChildrenCount
      }
    },
    getInfoConfiguration () {
      getInfoConfiguration('IS_SHOW_CONTACT').then(res => {
        if (res.code === 0 && res.data) {
          this.isMobile = res.data.value
        } else {
          this.isMobile = 'F'
        }
      })
    },
    handleCloseAnnouncement () {
      this.announcementdialogVisible = false
      this.msg = ''
    },
    getStringDicType (type) {
      let index = (this.specialCertificateType || []).findIndex(item => item.code === type)
      if (index !== -1) {
        return this.specialCertificateType[index].value
      } else {
        return type
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      let index = this.list.findIndex(item => item.ticketId === row.ticketId)
      let len = this.list[index].orderVisitorList.length
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        if (rowIndex === 0) {
          return [len, 1]
        } else {
          return [0, 0]
        }
      }
    },
    // 获取特殊身份证
    getDictList2 () {
      getDictList2().then(res => {
        if (res.code === 0) {
          this.specialCertificateType = res.data
        }
        this.initData()
      })
    },
    // 初始化订单数据
    initData () {
      this.total = 0
      this.count = 0
      const list = []
      this.list.forEach(val => {
        if (val.isAutoChoose === 'T') {
          for (var i = 0; i < val.selectNum; i++) {
            const v = JSON.parse(JSON.stringify(val))
            v.selectNum = 1
            list.push(v)
          }
        } else {
          list.push(val)
        }
      })
      this.list = list
      this.list.forEach(val => {
        this.count += parseInt(val.selectNum)
        this.total += val.selectNum * val.salePrice
        this.$set(val, 'orderVisitorList', [])
        const visitorCertificateType = val.certificateTypeList.length > 0 ? '1' : null
        for (var i = 0; i < val.selectNum; i++) {
          val.orderVisitorList.push({
            visitorName: '',
            visitorCertificateType,
            visitorCertificateNo: '',
            isSupportPrint: 'F',
            specialCertificate: '',
            ticketId: val.ticketId,
            specialCertificateTypeCn: val.needSpecialCertificate === 'T' ? this.getStringDicType(val.specialCertificate) : null,
            specialCertificateType: val.needSpecialCertificate === 'T' ? val.specialCertificate : null,
            isAutoChoose: val.isAutoChoose,
            canCarryChildrenCount: val.carryChildrenCount,
            carryChildrenCount: 0,
            childrenCount: 0,
            childTicketId: val.childTicketId
          })
        }
      })
      if (this.count < 10) {
        this.count = '0' + this.count
      }
    },
    // 获取系统参数配置的最大下单数
    getmaxQuantit () {
      maxQuantit().then(res => {
        if (res.code === 0) {
          this.maxQuantit = parseInt(res.data.value) || Infinity
        } else {
          console.error(res.error)
        }
      })
    },
    toPath (path) {
      this.$router.push(path)
    },
    // 数量修改
    handleQuantityChange () {
      this.list.map(item => {
        if (item.quantity < 0 || !item.quantity || item.quantity === null || item.quantity === '') { // 数量为空小于0时
          item.quantity = 0
        }
        item.quantity = parseInt(item.quantity) // 数量输入小点
        let length = item.quantity - item.orderVisitorList.length
        if (length > 0) {
          const visitorCertificateType = item.certificateTypeList.length > 0 ? '1' : null
          for (let index = 0; index < length; index++) {
            item.orderVisitorList.push({
              visitorName: '',
              visitorCertificateType,
              visitorCertificateNo: '',
              specialCertificate: '',
              isSupportPrint: 'F'
            })
          }
        } else if (length < 0) {
          for (var i = item.orderVisitorList.length - item.quantity; i > 0; i--) {
            item.orderVisitorList.splice(item.orderVisitorList.length - 1, 1)
          }
        }
        item.total = Number(math.format(item.quantity * item.salePrice, 14)).toFixed(2)
        this.count = item.quantity
        this.total = Number(math.format(item.quantity * item.salePrice, 14))
        return item
      })
      this.total = Number(this.total).toFixed(2)
    },
    qucikBuyCode () {
      qucikBuyCode().then(res => {
        if (res.code === 0) {
          this.codeshow = res.data.value !== 'F'
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          console.error(res.error)
        }
      })
    },
    validateInfo () {
      let ticketName
      for (let h = 0; h < this.list.length; h++) {
        let item = this.list[h] // 获取产品信息
        ticketName =
          item.ticketName +
          (item.ticketKindName ? '-' + item.ticketKindName : '')
        let cartProds = this.list[h].orderVisitorList
        let p = 0
        for (let i = 0; i < cartProds.length; i++) {
          if (cartProds.length > 0) {
            p = i + 1
          }
          if (specialSymbols(cartProds[i].visitorCertificateNo) && cartProds[i].visitorCertificateNo) {
            this.$message({
              message: `${ticketName}出行人${p || ''}的证件号包含特殊字符`,
              type: 'error'
            })
            return false
          }
          // 实名制的票，姓名，身份证号码必填
          if (item.isRealname === 'T') {
            if (
              cartProds[i].visitorName == null ||
              cartProds[i].visitorName.trim() === ''
            ) {
              this.$message({
                message: `请填写${ticketName}出行人${p || ''}的姓名`,
                type: 'error'
              })
              return false
            }
            if (cartProds[i].visitorCertificateType == null) {
              this.$message({
                message: `请选择${ticketName}出行人${p || ''}的证件类型`,
                type: 'error'
              })
              return false
            }
            if (
              cartProds[i].visitorCertificateNo == null ||
              cartProds[i].visitorCertificateNo.trim() === ''
            ) {
              this.$message({
                message: `请填写${ticketName}出行人${p || ''}的证件号`,
                type: 'error'
              })
              return false
            }
            // 验证身份证格式
            if (Number(cartProds[i].visitorCertificateType) === 1) {
              if (!validaIDCardNo(cartProds[i].visitorCertificateNo.toLocaleUpperCase())) {
                this.$message({
                  message: `${ticketName}-出行人${p ||
                    ''} , ${this.$t('FillOrder.PleaseCorrectInformation')}`,
                  type: 'error'
                })
                return false
              }
            }
          }
          if (item.needSpecialCertificate === 'T' && (cartProds[i].specialCertificate === '' || !cartProds[i].specialCertificate)) {
            this.$message.error(`请输入${item.ticketKindName}游客${i + 1}请输入特殊证件号`)
            return false
          }
        }
      }

      let cartFlag = this.validateRepeatCart(this.list)
      let freeFlag = this.validateFree(this.list)
      if (cartFlag) {
        this.$message({
          message: '不能填写重复证件号',
          type: 'error'
        })
        return false
      }
      if (freeFlag) {
        this.$message({
          message: '不能填写重复特殊证件号',
          type: 'error'
        })
        return false
      }
      return true
    },
    validateFree (carts) {
      // 循环判断是否有重复的
      let flag = false
      let freeNoList = []
      for (let i = 0; i < carts.length; i++) {
        if (carts[i].needSpecialCertificate === 'T') {
          for (let j = 0; j < carts[i].orderVisitorList.length; j++) {
            freeNoList.push(carts[i].orderVisitorList[j].specialCertificate)
          }
        }
      }
      let freeNoList2 = [...new Set(freeNoList)]
      if (freeNoList2.length !== freeNoList.length) {
        flag = true
      }
      return flag
    },
    validateRepeatCart (carts) {
      // 循环判断是否有重复的身份证
      let flag = false
      for (let i = 0; i < carts.length; i++) {
        for (let j = 0; j < carts[i].orderVisitorList.length; j++) {
          const find = carts[i].orderVisitorList[j]
          if (
            find.visitorCertificateNo &&
            find.visitorCertificateNo.trim().length > 0
          ) {
            for (let k = j + 1; k < carts[i].orderVisitorList.length; k++) {
              if (
                find.visitorCertificateNo ===
                  carts[i].orderVisitorList[k].visitorCertificateNo &&
                find.visitorCertificateType ===
                  carts[i].orderVisitorList[k].visitorCertificateType
              ) {
                flag = true
                break
              }
            }
            if (flag) {
              break
            }
          }
        }
        if (flag) {
          break
        }
      }
      return flag
    },
    certificateNo (checkArr) {
      let data = {
        number: checkArr.visitorCertificateNo
      }
      return new Promise((resolve, reject) => {
        certificateNo(data).then(res => {
          resolve(res)
        })
      })
    },

    validateBlackMobile () {
      let data = {
        visitorType: 'CONCAT_MOBILE',
        contactMobile: this.formData.contactMobile
      }
      return new Promise((resolve, reject) => {
        contactMobileValidate(data).then(res => {
          resolve(res)
        })
      })
    },
    submitBtn: throttle(function (formName) {
      this.submitBtnDeal(formName)
    }, 5000),
    async submitBtnDeal (formName) {
      console.log(this)
      // 校验联系人手机号黑名单
      const result = await this.validateBlackMobile()
      if (result.code !== 0) {
        this.msg = result.error
        this.announcementdialogVisible = true
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid && this.validateInfo()) {
          // 校验证件号黑名单
          let array = []
          let checkArray = []
          this.list.forEach((item, index) => {
            if (item.isRealname === 'T') {
              item.orderVisitorList.forEach((i, idx) => {
                if (i.visitorCertificateType === '1') {
                  checkArray.push({
                    visitorCertificateNo: i.visitorCertificateNo,
                    index: index,
                    idx: idx
                  })
                  array.push(this.certificateNo({
                    visitorCertificateNo: i.visitorCertificateNo,
                    index: index,
                    idx: idx
                  }))
                }
              })
            }
          })
          Promise.all(array).then(arr => {
            let k = 0
            let Prohibit = []
            arr.forEach((item, index) => {
              if (!item.data) {
                Prohibit.push(index)
                k = k + 1
              }
            })
            if (k > 0) {
              let msg = ''
              Prohibit.forEach(ite => {
                msg = msg + `${this.list[checkArray[ite].index].ticketName + (this.list[checkArray[ite].index].ticketKindName || '')}的第${checkArray[ite].idx + 1}个,`
              })
              msg = msg + '游客身份证地区被禁下单'
              this.msg = msg
              this.announcementdialogVisible = true
            } else {
              this.$refs.formVisitor.validate(res => {
                if (res) {
                  this.fullscreenLoading = true
                  if (this.codeshow) {
                    const data = {
                      code: this.formData.code,
                      mobilePhone: this.formData.contactMobile,
                      templateId: 'SMS_T_BUYCODE'
                    }
                    checkCode(data).then(res => {
                      if (res.code === 0) {
                        this.saveOrder()
                      } else if (res.code === 1017) {
                        this.$message({
                          message: '登录过期，安全性提醒：请重新登录',
                          type: 'error'
                        })
                        this.fullscreenLoading = false
                      } else {
                        this.fullscreenLoading = false
                        this.$message({
                          message: res.error,
                          type: 'error'
                        })
                      }
                    })
                  } else {
                    this.$confirm(this.$t('FillOrder.BeforeBy'), this.$t('FillOrder.ConfirmReminder'), {
                      confirmButtonText: this.$t('FillOrder.Confirmed'),
                      cancelButtonText: this.$t('FillOrder.DoubleConfirm'),
                      // showCancelButton: false,
                      type: 'warning'
                    }).then(() => {
                      this.saveOrder()
                    }).catch(() => {
                      this.fullscreenLoading = false
                      this.$message({
                        type: 'info',
                        message: '已取消操作'
                      })
                    })
                  }
                }
              })
            }
          })
        }
      })
    },
    saveOrder () {
      const orderDetailList = []
      this.list.forEach(item => {
        if (item.selectNum > 0) {
          // 将身份证转换成大写
          item.orderVisitorList.forEach(item => {
            item.visitorCertificateNo = item.visitorCertificateNo.toLocaleUpperCase()
          })

          if (item.isRealname === 'F') {
            item.orderVisitorList.map(x => {
              x.visitorCertificateType = null
              return x
            })
          }
          orderDetailList.push({
            currentSalePrice: item.salePrice,
            orderVisitorList: item.orderVisitorList,
            quantity: item.selectNum,
            ticketId: item.ticketId,
            ticketKindId: item.ticketKindId,
            useStartDate: this.date + ' 00:00:00',
            staggeredReservationDailyId: item.isStaggeredReservation === 'T' ? this.$route.query.reservationId : null
          })
        }
      })
      // 儿童票处理
      let parentCertificateNo = ''
      const orderDetailList2 = JSON.parse(JSON.stringify(orderDetailList))
      orderDetailList2.forEach(item => {
        const obj = {
          quantity: 0,
          staggeredReservationDailyId: this.$route.query.reservationId,
          ticketId: null,
          ticketKindId: null,
          useStartDate: item.useStartDate,
          orderVisitorList: []
        }
        item.orderVisitorList.forEach((i, idx) => {
          if (!i.parentTicketId) {
            parentCertificateNo = i.visitorCertificateNo
          } else {
            i.parentCertificateNo = parentCertificateNo
            obj.ticketId = i.subTicketId
            obj.quantity++
            obj.orderVisitorList.push(i)
            item.orderVisitorList.splice(idx, 1, null)
          }
        })
        item.orderVisitorList = item.orderVisitorList.filter(i => i)
        if (obj.quantity) {
          orderDetailList2.push(obj)
        }
      })
      const params = {
        contactMobile: this.formData.contactMobile,
        customerId: 'SAN_KE',
        orderDetailList: orderDetailList2
      }

      createOrder(params).then(res => {
        if (res.code === 0) {
          if (res.data.itemTotal > 0) {
            this.fullscreenLoading = false
            const query = {
              orderNo: res.data.orderNo,
              goodsNum: this.count,
              ticketList: JSON.stringify(this.list)
            }
            if (this.$route.query.reservationId) {
              query.reservationId = this.$route.query.reservationId
            } else {
              query.selectDate = this.$route.query.selectDate
            }
            this.$router.push({
              path: '/payOrder',
              query
            })
          } else {
					  this.saveFreeOrder(res.data.orderNo, this.list, params)
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
          this.fullscreenLoading = false
        } else {
          this.fullscreenLoading = false
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    deleteList (index, ind) {
      if (this.list[index].orderVisitorList[ind].childrenCount === 0) {
        this.list[index].selectNum -= 1
      } else {
        if (this.list[index].orderVisitorList[ind].childrenCount) {
          this.reduceAll(index, ind + 1)
          this.list[index].selectNum -= 1
        } else {
          this.reduceItem(index, ind)
        }
      }

      this.list[index].orderVisitorList.splice(ind, 1)
      this.count = 0
      this.total = 0
      this.list.forEach(val => {
        this.count += parseInt(val.selectNum)
        this.total += val.selectNum * val.salePrice
      })

      // 如果数量少于1，跳回首页
      if (this.count <= 0) {
        this.tiggerPage()
      }
    },
    reduceAll (index, ind) {
      if (this.list[index].orderVisitorList[ind] && !this.list[index].orderVisitorList[ind].childrenCount && this.list[index].orderVisitorList[ind].childrenCount !== 0) {
        this.list[index].orderVisitorList.splice(ind, 1)
        this.reduceAll(index, ind)
      }
    },
    reduceItem (index, ind) {
      // 已经删除了元素，现在改变下状态
      // 如果是删除父元素
      if (this.list[index].orderVisitorList[ind].childrenCount) {
        this.$set(this.list[index].orderVisitorList[ind], 'childrenCount', this.list[index].orderVisitorList[ind].childrenCount - 1)
        this.$set(this.list[index].orderVisitorList[ind], 'carryChildrenCount', this.list[index].orderVisitorList[ind].carryChildrenCount - 1)
      } else {
        this.reduceItem(index, ind - 1)
      }
    },
    // 免费订单支付接口
    saveFreeOrder (orderNo, orderList, orderData) {
      const arr = orderList.map(val => `${val.ticketName}*${val.quantity}`)
      const data = {
        orderNo
      }
      payAndConfirm(data).then(res => {
        this.fullscreenLoading = false
        if (res.code === 0) {
          this.$router.push({
            path: '/paySucceed',
            query: {
              orderData: JSON.stringify(orderData)
            }
          })
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
          this.$router.push({
            path: '/payFailed'
          })
        }
      })
    },
    tiggerPage () {
      this.$router.go(-1)
    },
    getVerificationCode () {
      if (!validaCellPhone(this.formData.contactMobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      } else {
        const data = {
          templateId: 'SMS_T_BUYCODE',
          mobilePhone: this.formData.contactMobile
        }
        sendCode(data).then(res => {
          if (res.code === 0) {
            this.verificationBtn = false
            this.verificationTime = 60
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (--this.verificationTime <= 0) {
                this.verificationBtn = true
                clearInterval(this.timer)
              }
            }, 1000)
          } else if (res.code === 1017) {
            this.$message({
              message: '登录过期，安全性提醒：请重新登录',
              type: 'error'
            })
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
          }
        })
      }
    },
    getTicketKind (row, index) {
      if (row.isAutoChoose === 'T') {
        const data = {
          idCardNo: row.visitorCertificateNo,
          ticketId: row.ticketId
        }
        getTicketKind(data).then(res => {
          if (res.code === 0) {
            this.list[index].ticketKindId = res.data.id
            this.$set(this.list[index], 'ticketKindName2', res.data.kindName)
          } else {
            this.$message.error(res.error)
          }
        })
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped lang="scss">
.fillOrder_box {
  padding: 20px;
  width: 1280px;
  margin: 0 auto;
  background: white;
  position: relative;
  .warm-prompt {
    margin-bottom: 28px;
    label {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 16px;
      color: #FF0000;
      opacity: 1;
    }
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #FF0000;
      opacity: 1;
    }
  }
  .schedule {
    position: absolute;
    right: -185px;
    top: 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 165px;
      height: 40px;
      background: #853D3F;
      color: #FFFFFF;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    .content {
      padding: 16px 16px;
      background: white;
      padding-right: 0;
      .activity {
        color: #853D3F;
      }
    }
  }
  .order-table .el-table__body-wrapper .el-table__row{
    background: none;
  }
  .el-form-item {
    margin-bottom: 0 !important;
    .el-form-item__error {
      position: initial !important;
      float: left !important;
    }
  }

}

.fillIn-box {
  display: flex;
}
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
  position: relative;
  .back {
    width: 130px;
    height: 44px;
    font-size: 16px;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
    float: right;
    border-radius: 6px;
    background: #241008;
    color: #fff;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #737B8C;
    opacity: 1;
    margin-bottom: 20px;
    line-height: 13px;
  }
  .backToClose {
    position: absolute;
    right: 0;
    top: 20px;
  }
}

// .title::before {
//   content: "";
//   float: left;
//   width: 5px;
//   height: 28px;
//   background-color: #ffe7ae;
//   margin-top: 19px;
//   margin-right: 10px;
// }

.ticket-msg {
  padding-left: 26px;
  p {
    overflow: hidden;
    font-weight: bold;
    font-size: 18px;
    line-height: 46px;
    span {
      float: left;
      width: 120px;
      text-align: left;
      line-height: 46px;
      font-weight: bold;
    }
  }
}

.ticketMsg {
  border: 1px solid #ffe7ae;
  padding: 20px 25px;
  background-color: #fff;
  margin-bottom: 20px;
  position: relative;
}

.ticketMsg p {
  font-size: 18px;
  font-weight: bold;
  color: #4d4d4d;
  line-height: 30px;
}

.blue {
  color: #21a4ff;
  font-weight: bold;
}

.visitorMsg {
  // border: 1px solid #ccc;
  background-color: #fff;
  margin-bottom: 20px;
  /deep/ .el-form-item__error {
    position: relative;
  }
}

.headline {
  // background-color: #f1f1f1;
  line-height: 46px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 24px;
  color: #424855;
  height: 46px;
}

.headline .sub {
  font-size: 16px;
  font-weight: bold;
}

.sub-sum {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 18px;
}

.sub-sum .msg {
  float: right;
  font-weight: bold;
}

.sub-sum .price {
  color: #ff6c1a;
  font-weight: bold;
}

.visitorMsg .msgForm {
  // margin: 0 25px;
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid #ccc;
}
.msgFormNoTop {
  margin: 0 0 !important;
  padding-bottom: 0 !important;
  padding-top: 1px !important;
}
.visitorMsg .msgForm:nth-last-child(1) {
  border-bottom: none;
}
.msgFormTitle2 {
  text-align: center;
  color: #2c3e50;
  font-weight: bold;
  line-height: 40px;
  flex: 1;
}
.msgFormTitle {
  text-align: center;
  color: #2c3e50;
  font-weight: bold;
  line-height: 40px;
  flex: 1;
}
.msgFormTitle::after {
  content: "*";
  color: red;
}
.submitOrder {
  position: relative;
  // border: 1px solid #ccc;
  height: 80px;
  line-height: 80px;
  color: #4d4d4d;
  background-color: #fff;
  text-align: right;
  padding-right: 215px;
  // margin-bottom: 60px;
  font-size: 20px;
}

.submitBtn {
  position: absolute;
  top: 50%;
  right: 32px;
  height: 44px;
  width: 140px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  background: #3987E1;
  font-family: PingFang SC;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  margin-top: -29px;
}
.submitBtn:active {
  opacity: 0.8;
}

.el-icon-success {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: goldenrod;
}

.el-icon-error {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: red;
}
.bold {
  font-weight: bold;
  line-height: 37px;
  height: 37px;
  padding: 0 15px;
}
</style>
